import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p } from "~/misc/common";

export default class extends Controller {
	connect() {
		console.log('initGroupReport1Show');
		const data = $('#toJs').data('magicdata');
		const students = $('#toJs').data('magicstudents');
		p(data);
		$('#magicData').on('click', function () {
			navigator.clipboard.writeText(JSON.stringify(data));
		});
		$('#magicStudents').on('click', function () {
			navigator.clipboard.writeText(students);
		});
		$('#magicId').on('click', function () {
			navigator.clipboard.writeText(data.gid);
		});
	}
}
